/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa forms
 *
 */
Intesa.Forms = function () {

	var myForm = $('input[name="myForm"]').val();
	var isCIB = $('html').attr('data-bank') == 'CIB';
	var isSLO = $('html').attr('data-bank') == 'ISPSLOVENIA';
	var isPBZ = $('html').attr('data-bank') == 'PBZ';

	function recaptchaCallback() {
		$("#recaptchainput").val('true');
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			forms.checkPrivacy();
		}, 500);
	}

	function validationCallback() {
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			forms.checkPrivacy();
		}, 500);
	}

	/**
	 * Local variables
	 *
	 */
	var forms = this;

	/**
	 * Init component
	 *
	 */
	this.init = function () {

		if (isPBZ && (!isCIB || !isSLO)) {
			window.intesa.forms = null;
			return;
		}
		console.log("init cib");

		window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? validationCallback : recaptchaCallback;


		if (isCIB) {
			forms.sessionMortage = [{
				"form1": {
					"basicQuestionsOne": "",
					"basicQuestionsTwo": "",
					"basicQuestionsThree": "",
					"basicQuestionsFour": "",
					"basicQuestionsFive": "",
					"installment": "",
					"tenor": "",
					"loanAmount": "",
					"productId": "",
					"productName": "",
					"interestRate": "",
					"interestPeriod": "",
					"loanPurpose": ""
				}, "form2": {
					"debitorIncomeOne": "",
					"debitorIncomeTwo": "",
					"debitorIncomeThree": "",
					"debitorIncomeFour": "",
					"installmentExistingsLoan": "",
					"existingCreditCardLimit": "",
					"existingOverdraftLimit": "",
					"otherDeductionsExpenses": "",
					"step2Questions": "",
					"cashLoan": "ciao",
					"babyLoan": ""
				}, "form3": {
					"collateralOne": "",
					"locatedOne": "",
					"collateralTwo": "",
					"locatedTwo": "",
					"collateralThree": "",
					"locatedThree": ""
				}
			}];
		} else {
			forms.sessionMortage = [{
				"form1": {
					"basicQuestionsOne": "",
					"basicQuestionsTwo": "",
					"installment": "",
					"tenor": "",
					"loanAmount": "",
					"productId": "",
					"productName": "",
					"interestRate": "",
					"interestPeriod": "",
					"loanPurpose": ""
				},
				"form2": {
					"averageMonthlyIncome": "",
					"debitors": "",
					"debitorIncomeOne": "",
					"debitorIncomeTwo": "",
					"debitorIncomeThree": "",
					"dependentMembers": "",
					"childWith": "0",
					"supportChildWith": "0",
					"childWithout": "0",
					"adult": "0",
					"retiree": "0",
					"monthlyLoan": "",
					"monthlyLoanAmount1": "",
					"monthlyLoanAmount2": "",
					"creditCard": "",
					"creditCardLimit": "",
					"overdraft": "",
					"overdraftLimit": ""
				},
				"form3": {
					"collateral": "",
					"collateralValue": "",
				}
			}];
		}

		var sessionJSON = sessionStorage.getItem('mortageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);
			forms.sessionMortage = JSON_Obj;
		}

		if ($('[data-component-r="formStep1Mortagage"]').length > 0 || $('[data-component-r="formStep2Mortagage"]').length > 0 || $('[data-component-r="formStep3Mortagage"]').length > 0 || $('[data-component-r="survey_loan"]').length > 0) {
			forms.refreshStep(1);
			forms.toggleAccordion();
			forms.formStep1Mortagage();
			forms.setActiveInput();
			forms.setActiveImport();
			forms.stepByStorage();
			forms.goToNext();
			forms.goBackStep();
			forms.plusMinus();
			forms.showHideLoan();
			forms.initStep();
			if ($("#privacystatus").length > 0) {
				forms.checkPrivacy();
			}
		}



	};

	/* --------------------- */


	this.initStep = function () {
		var sessionJSON = sessionStorage.getItem('mortageJSON') || '';
		var myForm = $('input[name="myForm"]').val();

		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);
			forms.sessionMortage = JSON_Obj;
		}

		if (!isCIB && forms.sessionMortage != '') {
			if (myForm == 'form3') {
				tenor = forms.sessionMortage[0].form1.tenor;
				loanAmount = forms.sessionMortage[0].form1.loanAmount

				if (forms.sessionMortage[0] != null && tenor > 20 && loanAmount > 50000) {
					$('.question2').removeClass('rhide');
				}
				else {
					$('.question1').removeClass('rhide');
				}
			}
		}
		var myForm = $('input[name="myForm"]').val();
		var sessionStorageMortage = JSON.parse(sessionStorage.getItem('mortageJSON'));
		var currStep = $(".r-cur-step").text();
		if (myForm == 'form2') {
			if (isCIB) {
				if (sessionStorageMortage[0].form2.debitorIncomeOne != "" && currStep == 6) {
					$('.rstepwrapper').eq(0).removeClass('rhide');
					forms.setActiveNext($('button.r-btn-next'));
				}
			}
			else {
				if (sessionStorageMortage[0].form2.averageMonthlyIncome != "" && currStep == 3) {
					$('.rstepwrapper').eq(0).removeClass('rhide');
					forms.setActiveNext($('button.r-btn-next'));
				}
			}

		}
	}

	this.stepByStorage = function () {
		var sessionJSON = sessionStorage.getItem('mortageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if (key == "installment" || key == "tenor" || key == "loanAmount" || key == "productId" || key == "productName" || key == "interestRate" || key == "interestPeriod" || key == "loanPurpose") continue;
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form1[key].length > 0) {
						showStep(key);
						$('input[name="' + key + '"]').each(function () {
							var self = this;
							if ($(self).val() == JSON_Obj[0].form1[key]) {
								$(self).attr('checked', true).parent('label').trigger('click');
							}
						});

						if (key == "basicQuestionsOne") {
							forms.setStep(1);
							forms.refreshStep(1);
							$('.rstep1').removeClass('rhide');
						}
						if (key == "basicQuestionsTwo") {
							forms.setStep(2);
							forms.refreshStep(2);
							$('.rstep2').removeClass('rhide');
						}
					}
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form2[key].length > 0) {
						if (isCIB) {
							if (key != "step2Questions") {
								$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);
							}
							else {
								if (key == "cashLoan" || key == "babyLoan") {
									if (JSON_Obj[0].form2["cashLoan"] != "" || JSON_Obj[0].form2["babyLoan"] != "") {
										console.log(key + " check cash/baby not empty");
										$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);
									}
								}

								JSON_Obj[0].form2["step2Questions"] == "yes" ? $(".rstepwrapper").eq(5).find('#hungary1').trigger('click') : $(".rstepwrapper").eq(5).find('#hungary2').trigger('click')
							}
						}
						else {
							if ($(self).attr('type') != "radio") {
								$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);
							}
						}

						var stepNumber = parseInt(forms.getStep());
						$(".rstepwrapper").eq(stepNumber - 1).find('input[name="' + key + '"]').trigger("keyup");

						$('input[name="' + key + '"]').each(function () {
							var self = this;
							if (isCIB) {
								if ($(self).val() == JSON_Obj[0].form2[key]) {
									$(self).attr('checked', true).parent('label').trigger('click');
								}
							} else {
								if ($(self).attr('type') == "radio" && $('input[name="' + key + '"]').length == 2) {
									if (!isCIB) {
										if (JSON_Obj[0].form2[key] == "no" || JSON_Obj[0].form2[key] == "ne") {
											$($('input[name="' + key + '"]')[1]).attr('checked', true).trigger('click');
											$($('input[name="' + key + '"]')[1]).val('ne');
											$($('input[name="' + key + '"]')[0]).val('da');

										}
										else {
											$($('input[name="' + key + '"]')[0]).attr('checked', true).trigger('click');
											$($('input[name="' + key + '"]')[0]).val('da');
											$($('input[name="' + key + '"]')[1]).val('ne');

										}

									} else {

										if (JSON_Obj[0].form2[key] == "no") {
											$($('input[name="' + key + '"]')[1]).attr('checked', true).trigger('click');
											$($('input[name="' + key + '"]')[1]).val('no');
											$($('input[name="' + key + '"]')[0]).val('yes');

										}
										else {
											$($('input[name="' + key + '"]')[0]).attr('checked', true).trigger('click');
											$($('input[name="' + key + '"]')[0]).val('yes');
											$($('input[name="' + key + '"]')[1]).val('no');

										}
									}
								}
							}

						});

						if (key == 'debitorIncomeOne') {
							$('.rstep1 .rvalue-increase').text(1);
							$(".rstepwrapper").eq(0).find(".mod-hom1").eq(0).removeClass("rhide");
						}
						if (key == 'debitorIncomeTwo') {
							$('.rstep1 .rvalue-increase').text(2);
							$(".rstepwrapper").eq(0).find(".mod-hom1").eq(1).removeClass("rhide");
						}
						if (key == 'debitorIncomeThree') {
							$('.rstep1 .rvalue-increase').text(3);
							$(".rstepwrapper").eq(0).find(".mod-hom1").eq(2).removeClass("rhide");
						}
						if (key == 'debitorIncomeFour') {
							$('.rstep1 .rvalue-increase').text(4);
							$(".rstepwrapper").eq(0).find(".mod-hom1").eq(3).removeClass("rhide");
						}

						if (isCIB) { $('.rstepwrapper').addClass('rhide'); }

						switch (key) {
							case 'debitorIncomeOne':
							case 'debitorIncomeTwo':
							case 'debitorIncomeThree':
							case 'debitorIncomeFour':
								if (isCIB) {
									forms.setStep(1);
									forms.refreshStep(1);
									$('.rstep1').removeClass('rhide');
								}
								break;
							case 'installmentExistingsLoan':
								if (isCIB) {
									forms.setStep(2);
									forms.refreshStep(2);
									$('.rstep2').removeClass('rhide');
								}
								break;
							case 'existingCreditCardLimit':
								forms.setStep(3);
								forms.refreshStep(3);
								$('.rstep3').removeClass('rhide');
								break;
							case 'existingOverdraftLimit':
								forms.setStep(4);
								forms.refreshStep(4);
								$('.rstep4').removeClass('rhide');
								break;
							case 'otherDeductionsExpenses':
								forms.setStep(5);
								forms.refreshStep(5);
								$('.rstep5').removeClass('rhide');
								break;
							case 'cashLoan':
							case 'babyLoan':
								forms.setStep(6);
								forms.refreshStep(6);
								$('.rstep6').removeClass('rhide');
								$('input[name="step2Questions"]').each(function () {
									var self = this;
									if ($(self).val() == 'yes') {
										$(self).attr('checked', true).parent('label').addClass('active');
									}
								});
								break;

							case "averageMonthlyIncome":
								forms.setStep(1);
								forms.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');

								break;
							case "debitors":
								if (localStorage.getItem('back') == 'true') {
									forms.setStep(2);
									forms.refreshStep(2);
									$('.rstepwrapper').addClass('rhide');
									$('.rstep2').removeClass('rhide');
								}
								break;
							case "dependentMembers":
								if (localStorage.getItem('back') == 'true') {
									forms.setStep(3);
									forms.refreshStep(3);
									$('.rstepwrapper').addClass('rhide');
									$('.rstep3').removeClass('rhide');
								}
								break;
							case "monthlyLoan":
								if (localStorage.getItem('back') == 'true') {
									forms.setStep(4);
									forms.refreshStep(4);
									$('.rstepwrapper').addClass('rhide');
									$('.rstep4').removeClass('rhide');
								}
								break;
							case "creditCard":
								if (localStorage.getItem('back') == 'true') {
									forms.setStep(5);
									forms.refreshStep(5);
									$('.rstepwrapper').addClass('rhide');
									$('.rstep5').removeClass('rhide');
								}
								break;
							case "overdraft":
								if (localStorage.getItem('back') == 'true') {
									forms.setStep(6);
									forms.refreshStep(6);
									$('.rstepwrapper').addClass('rhide');
									$('.rstep6').removeClass('rhide');
								}
								break;
							default:
								if (isCIB) {
									forms.setStep(1);
								}
						}
					}
				}
			}
		}

		if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
			for (var key in JSON_Obj[0].form3) {
				if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form3[key].length > 0) {

					if (!isCIB) {
						forms.setStep(9);
						forms.refreshStep(9);
						$('.rstep1').removeClass('rhide');
					}

					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger('focus');
					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger("keyup");

					if (key == 'collateralOne') {
						$('.rstep1 .rvalue-increase').text(1);
						var curstepwrapper = $(".rstepwrapper").eq(0);
						curstepwrapper.find(".mod-hom1").eq(0).removeClass("rhide");
					}
					if (key == 'collateralTwo') {
						$('.rstep1 .rvalue-increase').text(2);
						var curstepwrapper = $(".rstepwrapper").eq(0);
						curstepwrapper.find(".mod-hom1").eq(1).removeClass("rhide");
					}
					if (key == 'collateralThree') {
						$('.rstep1 .rvalue-increase').text(3);
						var curstepwrapper = $(".rstepwrapper").eq(0);
						curstepwrapper.find(".mod-hom1").eq(2).removeClass("rhide");
					}
				}
			}
		}
	}

	function showStep(key_obj) {
		$('.rstepwrapper').addClass('rhide');

		if (key_obj.indexOf('One') > -1) {
			$('.rstep1').removeClass('rhide');
			forms.setStep(1);
			forms.refreshStep(1);
		}
		if (key_obj.indexOf('Two') > -1) {
			$('.rstep2').removeClass('rhide');
			forms.setStep(2);
			forms.refreshStep(2);
		}
		if (key_obj.indexOf('Three') > -1) {
			$('.rstep3').removeClass('rhide');
			forms.setStep(3);
			forms.refreshStep(3);
		}
		if (key_obj.indexOf('Four') > -1) {
			$('.rstep4').removeClass('rhide');
			forms.setStep(4);
			forms.refreshStep(4);
		}
		if (key_obj.indexOf('Five') > -1) {
			$('.rstep5').removeClass('rhide');
			forms.setStep(5);
			forms.refreshStep(5);
		}
	}


	this.goToNext = function () {
		$(document).on('click', 'button.r-btn-next', function (e) {

			localStorage.removeItem('back');

			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) + 1;

			var myForm = $('input[name="myForm"]').val();

			if (myForm == 'form2') {
				if (isCIB) {
					if ($("[name='step2Questions']:checked").val() == "no") {
						forms.sessionMortage[0].form2.cashLoan = '';
						forms.sessionMortage[0].form2.babyLoan = '';
					}
					else {
						if ($("[name='step2Questions']:checked").val() == "yes") {
							forms.sessionMortage[0].form2.step2Questions = $("[name='step2Questions']:checked").val();
							forms.sessionMortage[0].form2.cashLoan = $('input[name="babyLoan"]').val();
							forms.sessionMortage[0].form2.babyLoan = $('input[name="cashLoan"]').val();
						}
					}
				}
			}

			sessionStorage.setItem('mortageJSON', JSON.stringify(forms.sessionMortage));

			if (myForm == 'form1') {
				sessionStorage.setItem('mortageStep', '1');
			}
			if (myForm == 'form2') {
				sessionStorage.setItem('mortageStep', '2');
			}
			if (myForm == 'form3') {
				sessionStorage.setItem('mortageStep', '3');
			}

			if (dataStepNew > $("#numberofsteps").val()) {
				var myForm = $('input[name="myForm"]').val();

				var sessionStorageMortage = sessionStorage.getItem('mortageJSON');
				if (sessionStorageMortage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortage);
				}

				if (myForm == 'form1') {
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
						for (var key in JSON_Obj[0].form1) {
							if (JSON_Obj[0].form1[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
							} else if (key == 'installment' || key == 'loanAmount' || key == 'tenor' || key == 'interestPeriod' || key == 'interestRate' || key == 'productName' || key == 'productId' || key == 'loanPurpose') {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}
				}
				if (myForm == 'form2') {
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
						for (var key in JSON_Obj[0].form1) {
							if (JSON_Obj[0].form1[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
							}
						}
					}
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
						for (var key in JSON_Obj[0].form2) {
							if (JSON_Obj[0].form2[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
							} else {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}

				}
				if (myForm == 'form3') {
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
						for (var key in JSON_Obj[0].form1) {
							if (JSON_Obj[0].form1[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
							}
						}
					}
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
						for (var key in JSON_Obj[0].form2) {
							if (JSON_Obj[0].form2[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
							} else {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
						for (var key in JSON_Obj[0].form3) {
							if (JSON_Obj[0].form3[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
							} else {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}
				}

				$('form#formTemp').submit();
			} else {
				forms.disableNext($('button.r-btn-next'));

				var myForm = $('input[name="myForm"]').val();

				if (myForm == 'form1') {

					setTimeout(function () {

						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {

							$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');

						} else {

							forms.disableNext(self);

						}

					}, 100);

				}

				if (myForm == 'form2') {

					setTimeout(function () {

						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {

							if (!isCIB) {
								$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
									var self = $(this);
									if (self.is(':checked')) {
										forms.setActiveNext($('button.r-btn-next'));
									}
								});

								// controllo sui plusminus se contengono un elemento diverso da 0 per attivare il bottone
								var mortageForm = JSON.parse(sessionStorage.getItem('mortageJSON'))[0].form2
								$(".rstepwrapper").eq(dataStepNew - 1).find('div[data-val]').each(function (index, elem) {
									var value = mortageForm[elem.id];
									elem.innerHTML = value;
									if (elem.innerText != "0") {
										elem.parentNode.children[0].classList.remove('disabled');
										forms.setActiveNext($('button.r-btn-next'));
									}
								});

								if (dataStepNew - 1 == 1) {
									for (var i = 0; i < mortageForm["debitors"]; i++) {
										$(".rstepwrapper").eq(dataStepNew - 1).find('.col-md-10')[i].classList.remove('rhide');
									}
								}

								if (mortageForm["childWith"] > 0) {
									$(".supportInput").removeClass("rhide");
								}
							}

							var mortageForm = JSON.parse(sessionStorage.getItem('mortageJSON'))[0].form2;
							if ((mortageForm["step2Questions"] == "yes" || mortageForm["step2Questions"] == "da") && dataStepNew == "6") {
								$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-showloan]').trigger('click');
								$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-showloan]').parent('.rcontainer-input').trigger('click');
							}

							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':visible')) {
									self.trigger("keyup");
								}
							});

						} else {
							if (!isCIB && $('button.r-btn-next').attr('data-step') == 2) {
								forms.setActiveNext($('button.r-btn-next'));
							}
							else {
								forms.disableNext($('button.r-btn-next'));
							}
						}

					}, 100);

				}

				forms.refreshStep(dataStepNew);
				forms.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');
			}

			forms.showHideLoan();
			forms.scrollToTop();
			if (!isCIB) {
				forms.initStep();
			}
			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
			if (!isCIB) {
				if (dataStepNew > $("#numberofsteps").val()) {
					window.location.replace($("#submit").attr("data-redirect"));
				}
			}
		});
	};

	//scroll to top
	this.scrollToTop = function () {
		var xtop = 0;
		$('html, body').animate({ scrollTop: xtop }, '500');
	}

	if ($(".r-form-top-section").length > 0) {
		forms.scrollToTop();
	}

	this.goBackStep = function () {
		$(document).on('click', 'button.r-btn-back', function (e) {

			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var myForm = $('input[name="myForm"]').val();

			if (dataStepNew < 1) {
				var gotoform = "";
				var mortageForm = localStorage.getItem('mortageForm') || "";
				if (mortageForm !== "") {
					mortageForm = JSON.parse(mortageForm);

					//if (myForm == 'form1') { gotoform = mortageForm.form1 }
					if (myForm == 'form1') { gotoform = mortageForm.landing }
					if (myForm == 'form2') { gotoform = mortageForm.form1 }
					if (myForm == 'form3') { gotoform = mortageForm.form2 }

					if (gotoform !== "") {
						localStorage.setItem('back', "true");
						window.location.href = gotoform;
					}
				}
				//history.back(1);
			} else {

				forms.disableNext($('button.r-btn-next'));

				if (myForm == 'form1') {
					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {
							$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');
						} else {
							forms.disableNext($('button.r-btn-next'));
						}
					}, 100);
				}

				if (myForm == 'form2') {

					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {
							var mortageForm = JSON.parse(sessionStorage.getItem('mortageJSON'))[0].form2

							// controllo sui radio per attivare il bottone
							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':checked')) {
									forms.setActiveNext($('button.r-btn-next'));
								}
							});

							if (!isCIB) {
								// controllo sui plusminus se contengono un elemento diverso da 0 per attivare il bottone
								$(".rstepwrapper").eq(dataStepNew - 1).find('div[data-val]').each(function (index, elem) {
									var value = mortageForm[elem.id];
									elem.innerHTML = value;
									if (elem.innerText != "0") {
										elem.parentNode.children[0].classList.remove('disabled');
										forms.setActiveNext($('button.r-btn-next'));
										if (elem.id == "supportChildWith") {
											elem.parentNode.children[2].classList.add('disabled');
										}
									}
								});

								// Nello step2 mostro tanti input quanti indicati dal + - sopra
								// Itero sul numero fornito nel primo giro e tolgo il hide a n elementi
								if (dataStepNew - 1 == 1) {
									for (var i = 0; i < mortageForm["debitors"]; i++) {
										$(".rstepwrapper").eq(dataStepNew - 1).find('.col-md-10')[i].classList.remove('rhide');
									}
								}

								if (mortageForm["childWith"] > 0) {
									$(".supportInput").removeClass("rhide");
								}
							}

							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':visible')) {
									self.trigger("keyup");
								}
							});

						} else {
							forms.setActiveNext($('button.r-btn-next'));
						}
					}, 100);
				}

				forms.refreshStep(dataStepNew);
				forms.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');

			}

			forms.showHideLoan();
			forms.scrollToTop();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
		});
	}

	this.formStep1Mortagage = function () {
		forms.setStep(1);
	}

	//set active input
	this.setActiveInput = function () {
		$(".rcontainer-input").on("click", function () {
			var name = $(this).find('input').attr("name");
			$('[name=' + name + ']').parent().removeClass("active");
			$(this).addClass("active");

			var myForm = $('input[name="myForm"]').val();

			if (myForm == 'form1') {
				var stepNumber = parseInt(forms.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked");
				if (chekToInput) forms.sessionMortage[0].form1[name] = $('[name=' + name + ']:checked').val();
			}

			if (myForm == 'form2') {
				var stepNumber = parseInt(forms.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked");
				forms.sessionMortage[0].form2[name] = $('[name=' + name + ']:checked').val();
			}

			if (myForm == 'form3') {
				var stepNumber = parseInt(forms.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked");
				forms.sessionMortage[0].form3[name] = $('[name=' + name + ']:checked').val();
			}


			forms.showError(forms.getStep());
		});

	}

	this.setActiveImport = function () {
		$(".rcontainer-import input").on("keyup", function () {
			var self = $(this);
			if (self.val().length > 0) {

				if ((self.attr("name") == "babyLoan") || (self.attr("name") == "cashLoan")) {
					if (($("[name=cashLoan]").val().length > 0) && ($("[name=babyLoan]").val().length > 0)) {
						forms.setActiveNext($('button.r-btn-next'));
					} else {
						forms.disableNext($('button.r-btn-next'));
					}
				} else {
					forms.setActiveNext($('button.r-btn-next'));
				}

				if ($(".rstepwrapper").eq(parseInt(forms.getStep()) - 1).find("input").length > 1 && $(".rstepwrapper").eq(parseInt(forms.getStep()) - 1).find('.rcontainer-import').attr('data-showhideloan') == undefined) {
					$(".rstepwrapper").eq(parseInt(forms.getStep()) - 1).find("input").each(function () {
						if ($(this).is(':visible') && $(this).val() == '') {
							forms.disableNext($('button.r-btn-next'));
							return;
						}
					});
				}

				var name = $(this).attr("name");
				var myForm = $('input[name="myForm"]').val();

				if (myForm == 'form2') {
					if (isCIB) {
						forms.sessionMortage[0].form2[name] = $('[name=' + name + ']').val().replace(/ /g, '');
					} else {

						if ($('[name=' + name + ']').attr('type') != "radio" && $('[name=' + name + ']').length > 1) {
							for (var i = 0; i < $('[name=' + name + ']').length; i++) {
								if ($($('[name=' + name + ']')[i]).val() != "") {
									forms.sessionMortage[0].form2[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
								}
							}
						} else {
							forms.sessionMortage[0].form2[name] = $('[name=' + name + ']').val().replace(/ /g, '');
						}
					}
				}

				if (myForm == 'form3') {
					if ($('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								forms.sessionMortage[0].form3[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						forms.sessionMortage[0].form3[name] = $('[name=' + name + ']').val().replace(/ /g, '');
					}
				}
			} else {
				forms.disableNext($('button.r-btn-next'));
			}
		});
	}

	//refresh the step progress
	this.refreshStep = function (step) {
		var myForm = $('input[name="myForm"]').val();
		var totalSteps;
		if (!isCIB) {
			totalSteps = "9";
		}
		else {
			totalSteps = "12";
		}

		if (!isCIB) {
			if (myForm == 'form2') {
				step += 2;
			}

			if (myForm == 'form3') {
				step += 8;
			}
		}
		else {
			if (myForm == 'form2') {
				step += 5;
			}
			if (myForm == 'form3') {
				step += 11;
			}
		}

		if ((step !== null) && (step !== "") && (step !== undefined)) {
			$(".r-cur-step").text(step);
			if ((totalSteps !== null) && (totalSteps !== "") && (totalSteps !== undefined)) {
				$(".r-tot-step").text(totalSteps);
				$(".r-progress-bar-fill").width(parseInt(step) / parseInt(totalSteps) * 100 + "%");
			}
		}
		//forms.scrollToTop();
	}

	//set button next active
	this.setActiveNext = function (thisBtn) {
		thisBtn.addClass("active").prop("disabled", false);
	}

	//disable button next
	this.disableNext = function (thisBtn) {
		thisBtn.removeClass("active").prop("disabled", true);
	}

	//get the current step number
	this.getStep = function () {

		var stepNumber = $('button.r-btn-next').attr('data-step');
		return stepNumber;

	}

	//show the error msg
	this.showError = function (stepNumber) {
		stepNumber = parseInt(stepNumber);
		var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked") || false;
		if (curstepwrapper || curstepwrapper == "true") {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").addClass('rhide'); //hide the error
			forms.setActiveNext($('button.r-btn-next'));
		} else {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").removeClass('rhide'); //show the error
			forms.disableNext($('button.r-btn-next'));
		}

	}

	//set the current step number
	this.setStep = function (stepNumber) {
		$(".r-form-submit-wrapper button").attr("data-step", stepNumber);
		forms.refreshStep(stepNumber);
	}

	//toggle form accordion
	this.toggleAccordion = function () {

		$('[data-accordion="title"]').on("click", function () {

			$(this).addClass("rhide");
			$(this).next('[data-accordion="detail"]').removeClass("rhide");

		});

		$('[data-accordion="detail"] .rtitle-accordotion').on("click", function () {

			$(this).parent().addClass("rhide");
			$(this).parent().prev('[data-accordion="title"]').removeClass("rhide");

		});

	}

	//plus minus
	this.plusMinus = function (val) {

		if ($("[data-plusminus]").length > 0) {

			$("[data-plusminus]").each(function (index, elem) {

				if ((val !== null) && (val !== undefined) && (val !== "")) {
					$(elem).find("[data-val]").text(val);
				}

				var thisMax = $(elem).attr("data-maximum");

				var curVal = $(elem).find("[data-val]").text();
				var thisMinus = $(elem).find("[data-minus]");
				var thisPlus = $(elem).find("[data-plus]");


				thisMinus.removeClass("disabled");
				thisPlus.removeClass("disabled");
				if (curVal == "0") {
					thisMinus.addClass("disabled");
				}

				if (curVal == thisMax) {
					thisPlus.addClass("disabled");
				}

			});
			if (!isCIB) {
				if ($('input[name="myForm"]').val() == 'form2') {
					if ($('button.r-btn-next').attr('data-step') == 3) {
						$('a.btnMinus').splice(1).forEach(function (entry) {
							if (!$(this).hasClass("disable")) {
								forms.setActiveNext($('button.r-btn-next'));
							}
						});
					}
				}

				// Qui immagazzino i valori dei + - nel session
				$('.rvalue-increase').each(function (index, elem) {
					var id = elem.id;
					forms.sessionMortage[0].form2[id] = elem.innerText;
				})
			}
		}
	}

	$("[data-landing]").on("click", function () {
		var mortageFormOBJ = JSON.parse(localStorage.getItem('mortageForm'));
		//if (!isCIB) {
		mortageFormOBJ.landing = window.location.pathname;
		//}
		if (mortageFormOBJ != undefined) {
			mortageFormJSON = JSON.stringify(mortageFormOBJ);
			localStorage.setItem('mortageForm', mortageFormJSON);
		}
	})

	//Open form mortgage
	$("[data-openmortgageform]").on("click", function () {

		forms.getInputs(this);

		var calcLnk = window.location.pathname;
		var form1lnk = $(this).attr("data-openmortgageform") || "";
		var form2lnk = $(this).attr("data-openmortgageform2") || "";
		var form3lnk = $(this).attr("data-openmortgageform3") || "";
		var mortageFormOBJ = { "calc": calcLnk, "form1": form1lnk, "form2": form2lnk, "form3": form3lnk };
		mortageFormJSON = JSON.stringify(mortageFormOBJ);
		localStorage.setItem('mortageForm', mortageFormJSON);

		var mortageStep = sessionStorage.getItem('mortageStep') || "";
		if (mortageStep !== "") {
			if (mortageStep == "2") {
				window.location.href = $(this).attr("data-openmortgageform2");
			}
			if (mortageStep == "3") {
				window.location.href = $(this).attr("data-openmortgageform3");
			}
			if ((mortageStep !== "2") && (mortageStep !== "3")) {
				window.location.href = $(this).attr("data-openmortgageform");
			}
		} else {
			window.location.href = $(this).attr("href");
		}

		return false;

	});

	//get inputs for the form
	this.getInputs = function (element) {
		if (isCIB) {
			if ($('[data-active-tab="withsalary"]').hasClass("open")) { //if is promo

				var installment = "" + window.intesa.mortgage_calculator.monthlyInstallmentValuePromo || "";
				var interestRate = "" + window.intesa.mortgage_calculator.interestRateResultPromo || "";

			} else {

				var installment = "" + window.intesa.mortgage_calculator.monthlyInstallmentValueStandard || "";
				var interestRate = "" + window.intesa.mortgage_calculator.interestRateResultStandard || "";

			}

			var activeCalculator = $(element).parents("section[data-calculator]");

			var tenor = "" + window.intesa.mortgage_calculator.tenorValue || "";
			var loanAmount = "" + window.intesa.mortgage_calculator.borrowAmountValue || "";
			var productName = $("[name=fProductName]", activeCalculator).val() || "";
			var productId = $("[name=fProductId]", activeCalculator).val() || "";
			var interestPeriod = $("[name=fInterestPeriod]", activeCalculator).val() || "";
			var loanPurpose = $("[name=fLoanPurpose]", activeCalculator).val() || "";

			forms.sessionMortage[0].form1.loanAmount = loanAmount || '';
			forms.sessionMortage[0].form1.installment = installment || '';
			forms.sessionMortage[0].form1.tenor = tenor || '';
			forms.sessionMortage[0].form1.productId = productId || '';
			forms.sessionMortage[0].form1.productName = productName || '';
			forms.sessionMortage[0].form1.interestRate = interestRate || '';
			forms.sessionMortage[0].form1.interestPeriod = interestPeriod || '';
			forms.sessionMortage[0].form1.loanPurpose = loanPurpose || '';

		} else {
			if ($('[data-active-tab="withsalary"]').hasClass("open")) { //if is promo

				var installment = "" + window.intesa.loan_calculator_ispslovenia.firstMonthlyInstallment || "";
				var interestRate = "" + window.intesa.loan_calculator_ispslovenia.firstInterestRate || "";

			} else {

				var installment = "" + window.intesa.loan_calculator_ispslovenia.firstMonthlyInstallment || "";
				var interestRate = "" + window.intesa.loan_calculator_ispslovenia.firstInterestRate || "";

			}


			var tenor = "" + window.intesa.loan_calculator_ispslovenia.tenor || "";
			var loanAmount = "" + window.intesa.loan_calculator_ispslovenia.loanAmount || "";
			var productName = $("[name=fProductName]").val() || "";
			var productId = $("[name=fProductId]").val() || "";
			var interestPeriod = $("[name=fInterestPeriod]").val() || "";
			var loanPurpose = $("[name=fLoanPurpose]").val() || "";

			forms.sessionMortage[0].form1.loanAmount = loanAmount || '';
			forms.sessionMortage[0].form1.installment = installment || '';
			forms.sessionMortage[0].form1.tenor = tenor || '';
			forms.sessionMortage[0].form1.productId = productId || '';
			forms.sessionMortage[0].form1.productName = productName || '';
			forms.sessionMortage[0].form1.interestRate = interestRate || '';
			forms.sessionMortage[0].form1.interestPeriod = interestPeriod || '';
			forms.sessionMortage[0].form1.loanPurpose = loanPurpose || '';
		}

		sessionStorage.setItem('mortageJSON', JSON.stringify(forms.sessionMortage));

	}

	//show hide elements
	this.showHideElements = function (val) {

		if ((val !== null) && (val !== undefined) && (val !== "")) {

			var stepNumber = forms.getStep();
			var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1);
			curstepwrapper.find(".mod-hom1").addClass("rhide");
			val = parseInt(val);

			for (i = 0; i <= val - 1; i++) {
				curstepwrapper.find(".mod-hom1").eq(i).removeClass("rhide");
			}

			if (val > 0) forms.setActiveNext($('button.r-btn-next'));
			if ($(".rstepwrapper").eq(parseInt(forms.getStep()) - 1).find("input").length > 1) {
				$(".rstepwrapper").eq(parseInt(forms.getStep()) - 1).find("input").each(function () {
					if (($(this).is(':visible') && $(this).val() == '')) {

						if (!isCIB && forms.getStep() == 2) {
							forms.setActiveNext($('button.r-bth-next'));
						}
						forms.disableNext($('button.r-btn-next'));
						return;
					}
				});
			}
		}

	}

	this.resetForms2 = function (thisVal) {
		if (parseInt(thisVal) - 1 == 0) {
			$('input[name="debitorIncomeOne"]').val('');
			forms.sessionMortage[0].form2.debitorIncomeOne = "";
		}
		if (parseInt(thisVal) - 1 == 1) {
			$('input[name="debitorIncomeTwo"]').val('');
			forms.sessionMortage[0].form2.debitorIncomeTwo = "";
		}
		if (parseInt(thisVal) - 1 == 2) {
			$('input[name="debitorIncomeThree"]').val('');
			forms.sessionMortage[0].form2.debitorIncomeThree = "";
		}
		if (parseInt(thisVal) - 1 == 3) {
			$('input[name="debitorIncomeFour"]').val('');
			forms.sessionMortage[0].form2.debitorIncomeFour = "";
		}
	}

	this.resetForms3 = function (thisVal) {
		if (parseInt(thisVal) - 1 == 0) {
			$('input[name="collateralOne"]').val('');
			$('input[name="locatedOne"]').val('');
			forms.sessionMortage[0].form3.collateralOne = "";
			forms.sessionMortage[0].form3.locatedOne = "";
		}
		if (parseInt(thisVal) - 1 == 1) {
			$('input[name="collateralTwo"]').val('');
			$('input[name="locatedTwo"]').val('');
			forms.sessionMortage[0].form3.collateralTwo = "";
			forms.sessionMortage[0].form3.locatedTwo = "";
		}
		if (parseInt(thisVal) - 1 == 2) {
			$('input[name="collateralThree"]').val('');
			$('input[name="locatedThree"]').val('');
			forms.sessionMortage[0].form3.collateralThree = "";
			forms.sessionMortage[0].form3.locatedThree = "";
		}
	}

	// Resetta tutti i + - quando viene premuto NO
	if (!isCIB) {
		$("#dependent2").on("click", function () {
			$('.rvalue-increase').splice(1).forEach(function (elem) {
				elem.innerHTML = "0";
			})
			$(".btnMinus").splice(1).forEach(function (elem) {
				elem.classList.add("disabled");
			})
			$('.supportInput').addClass('rhide');
			forms.disableNext($('button.r-btn-next'));
		});
	}

	//decrease Value
	$("[data-minus]").on("click", function () {

		var thisCounter = $(this).next("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) - 1);
			forms.plusMinus();

			forms.showHideElements(parseInt(thisVal) - 1);

			if ($('input[name="debitorIncomeOne"]').length > 0) {
				forms.resetForms2(thisVal);
			}

			if ($('input[name="collateralOne"]').length > 0) {
				forms.resetForms3(thisVal);
			}
		}

		if (!isCIB) {
			if ($('button.r-btn-next').attr('data-step') == 2) {
				if ($('.rvalue-increase')[0].innerText == '0') {
					forms.setActiveNext($('button.r-btn-next'));
				}
			}

			if (($('button.r-btn-next').attr('data-step') == 2) || $('.rvalue-increase')[0].innerText == '0') {
				forms.setActiveNext($('button.r-btn-next'));
			}

			if ($('button.r-btn-next').attr('data-step') == 3) {
				var flag = true;
				$('.rvalue-increase').splice(1, 4).forEach(function (elem) {
					if (elem.innerHTML != '0') { flag = false; }
				});
				if (flag) {
					forms.disableNext($('button.r-btn-next'))
				}
			}
			if ($('.childSupport')[0].innerText == '0') {
				$('.supportInput').addClass('rhide');
			}
		}

	});


	var elem = $('.rcontainer-import')
	//show/hide loan form2
	$("[data-showloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").removeClass("rhide");
	});
	$("[data-hideloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").addClass("rhide").find("input").val("");
		if (!isCIB && myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortageForm = JSON.parse(sessionStorage.getItem('mortageJSON') || "")[0].form2;
		}
	});

	this.showHideLoan = function () {
		if (!isCIB) {
			if (forms.sessionMortage[0] != null) {
				if (forms.sessionMortage[0].form1.basicQuestionsOne == "Repayment of existing loans" || forms.sessionMortage[0].form1.basicQuestionsOne == "Poplačilo stanovanjskega kredita") {
					$('.case2-1').addClass('rhide');
				}
				else {
					$('.case2-2').addClass('rhide');
				}
			}
		}
	}

	//increase Value
	$("[data-plus]").on("click", function () {

		var thisCounter = $(this).prev("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) + 1);
			forms.plusMinus();

			forms.showHideElements(parseInt(thisVal) + 1);

			if (isCIB) {
				if (parseInt(thisVal) + 1 == 1) {
					$('input[name="debitorIncomeOne"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 2) {
					$('input[name="debitorIncomeTwo"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 3) {
					$('input[name="debitorIncomeThree"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 4) {
					$('input[name="debitorIncomeFour"]').trigger('keyup');
				}
			}
			if (!isCIB) {
				if ($('.childSupport')[0].innerText != '0') {
					$('.supportInput').removeClass('rhide');
				}
			}
		}
	});

	//set selected label as active
	$(".r-thankyou-time label").on("click", function () {
		$(".r-thankyou-time label").removeClass("active");
		$(this).addClass("active");
	});

	//accept only numbers
	$(document).on("input", ".r-thankyou-wrapper [name='prefixNumber'], .r-thankyou-wrapper [name='phoneNumber']", function (e) {
		$(this).val($(this).val().replace(/[^0-9]/g, ''));//allow only numbers
	});

	//check success form privacy status
	this.checkPrivacy = function () {
		var item_thanksName = "none";
		if ($("#item_thanksName").length > 0) {
			item_thanksName = $("#item_thanksName").val();
		}
		var thanksLastname = "none";
		if ($("#item_thanksLastname").length > 0) {
			thanksLastname = $("#item_thanksLastname").val();
		}
		var checkCaptcha = $("input[name='recaptchaKey']").length >= 1 || "" != $(".g-recaptcha-response").val() ? true : false;
		if (($("#privacystatus").is(":checked")) && ($("#item_email").val() !== "") && (item_thanksName !== "") && (thanksLastname !== "")
			&& ($('[name="prefixNumber"]').val() !== "") && ($('[name="phoneNumber"]').val() !== "")
			&& (checkCaptcha)) {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", false);
		} else {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", true);
		}
	}


	//change btn status after privacy changes
	$("#privacystatus").on("click", function () {

		forms.checkPrivacy();

	});

	$(".r-thankyou-wrapper input").on("change input", function (e) {
		forms.checkPrivacy();
	});

	//validate on focus out
	$('.r-thankyou-content input[required]').on("focusout blur", function () {
		$(this).parsley().validate();
	});

	$(document).ready(function () {
		if (localStorage.getItem('back') == 'true') {
			var myForm = $('input[name="myForm"]').val();
			var dataNewStep = 0;

			if (myForm == 'form1') {
				if (isCIB) { dataNewStep = 5; }
				else { dataNewStep = 2; }
			}
			if (myForm == 'form2') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep6').removeClass('rhide');
				dataNewStep = 6;
			}

			window.intesa.forms.setStep(dataNewStep);
			window.intesa.forms.refreshStep(dataNewStep);


			var mortageForm = JSON.parse(sessionStorage.getItem('mortageJSON') || "")[0].form2;
			if (myForm == 'form2') {
				if (isCIB) {
					if ((mortageForm["cashLoan"] != "" || mortageForm["babyLoan"] != "")) {
						$(".rstepwrapper").eq(dataNewStep - 1).find('input[data-showloan]').trigger('click');
						$(".rstepwrapper").eq(dataNewStep - 1).find('input[data-showloan]').parent('.rcontainer-input').trigger('click');
					}
				}
				else {
					if (mortageForm["averageMonthlyIncome"] != "") {
						$(".rstepwrapper").eq(dataNewStep - 1).find('input[data-showloan]').trigger('click');
						$(".rstepwrapper").eq(dataNewStep - 1).find('input[data-showloan]').parent('.rcontainer-input').trigger('click');
					}
				}

				if (!isCIB) {
					var mortageForm = JSON.parse(sessionStorage.getItem('mortageJSON') || "")[0].form2;
					var inputName = $(".rstepwrapper").eq(5).find('input[type=radio]').attr('name')
					if (mortageForm.inputName != "") {
						var value = mortageForm[inputName];
						$(".rstepwrapper").eq(5).find('input[value=' + value + ']').trigger('click');
						$(".rstepwrapper").eq(5).find('input[value=' + value + ']').parent('.rcontainer-input').trigger('click');
					}
				}

			}

			window.intesa.forms.setActiveNext($('button.r-btn-next'));
			localStorage.removeItem('back');
		}
	});


	//submit form success
	$(".r-thankyou-wrapper .j-privacy__btn").on("click", function (e) {

		e.preventDefault();

		//check parsley first
		var isformok = $('form[name="formThanksMortgage"]').parsley().validate();
		if (isformok) {

			// get all the inputs into an array.
			var $inputs = $('.r-thankyou-content :input');

			$inputs.each(function () {

				if ($(this).attr('name') !== undefined) {

					var vall = $(this).val() || "";
					var namee = $(this).attr('name') || "";

					if (namee == "privacystatus") {
						if ($(this).is(":checked")) {
							vall = "true";
						} else {
							vall = "false";
						}
					}

					if (namee == "radioTime") {
						if ($(this).is(":checked")) {
							$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
							$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
						} else {
							//
						}
						//
					} else {
						$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
						$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
					}

				}


			});

			if (isCIB) {
				var sessionStorageMortage = sessionStorage.getItem('mortageJSON') || "";
				if (sessionStorageMortage !== "") {
					if (sessionStorageMortage.length > 0) {
						var JSON_Obj = JSON.parse(sessionStorageMortage);
					}
				}

				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					for (var key in JSON_Obj[0].form1) {
						if (JSON_Obj[0].form1[key].length > 0) {
							$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					for (var key in JSON_Obj[0].form2) {
						if (JSON_Obj[0].form2[key].length > 0) {
							$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
						} else {
							$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
					for (var key in JSON_Obj[0].form3) {
						if (JSON_Obj[0].form3[key].length > 0) {
							$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
						} else {
							$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
						}
					}
				}

				$('form#formTemp').submit();
			} else {

				var sessionStorageMortage = sessionStorage.getItem('mortageJSON') || "";
				if (sessionStorageMortage !== "") {
					if (sessionStorageMortage.length > 0) {
						var JSON_Obj = JSON.parse(sessionStorageMortage);
					}
				}

				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					for (var key in JSON_Obj[0].form1) {
						if (JSON_Obj[0].form1[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					for (var key in JSON_Obj[0].form2) {
						if (JSON_Obj[0].form2[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace('&nbsp;', '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="0"/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
					for (var key in JSON_Obj[0].form3) {
						if (JSON_Obj[0].form3[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace('&nbsp;', '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="0"/>');
						}
					}
				}
				$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
				$('form[name="formThanksMortgage"]').submit();
			}

		}

		return false;


	});

	//delete sessionstorage if form is successfully sent
	if ($("[data-formsent]").length > 0) {
		sessionStorage.removeItem('mortageJSON');
		sessionStorage.removeItem('mortageStep');
	}

	//on resize, reset the wallpaper
	function resizedw() {
		if ($("[data-bgimg]").length > 0) {
			$("[data-bgimg]").each(function () {
				var imageUrl = $(this).attr("data-bgimg");
				$(this).css('background-image', 'url(' + imageUrl + ')');
			});
		}
	}

	var doit;
	window.onresize = function () {
		clearTimeout(doit);
		doit = setTimeout(resizedw, 10);
	};

	//replace placeholder in mortgage title
	var sessionStorageMortage = sessionStorage.getItem('mortageJSON') || "";
	if (sessionStorageMortage.length > 0) {
		var JSON_Obj = JSON.parse(sessionStorageMortage);
		var placeholder = JSON_Obj[0].form1["productName"] || "";
		if ($(".r-title").length > 0) {
			$(".r-title").each(function () {
				var thistitle = $(this).html();
				thistitle = thistitle.replace("${productName}", placeholder);
				$(this).html(thistitle);
			})
		}
	}

	/**
	 * Call to servlet
	 *
	 * @param {*} url
	 * @param {*} form
	 */
	this.callServlet = function (url, form) {

		$.ajax({

			type: "POST",
			data: form.serialize(),
			url: url,
			success: function (data) {

				console.log("success sending form");

			},
			error: function (data) {

				console.log("error sending form");

			}

		});

	};

	/**
	 * Trigger call to servlet
	 *
	 */
	/* this.callServletTrigger = function() {
	 
		$( "[data-call-servlet]" ).on( "click", function() {
	 
			  var formUrl = $( this ).attr( "data-call-servlet" );
			  var thisForm = $( this ).parent( "form" );
	 
			 setTimeout( function() {
	 
				 if( !thisForm.find( "*" ).hasClass( 'parsley-error' ) ) {
	 
					  forms.callServlet( formUrl, thisForm );
	 
				 } else {
	 
					 // console.log( "the form has at least an error" );
	 
				 }
	 
			 }, 300 ); // wait for the parsley script to do his magic
	 
		  } );
	 
	}; */

};

/**
 * Get class instance
 *
 */
Intesa.Forms.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.forms) {

		window.intesa.forms = new Intesa.Forms();

	}

	return window.intesa.forms;

};
      /**
* On DOM ready
*
*/
      // $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {
 
	// init component
	var forms = Intesa.Forms.getInstance();
	forms.init();
 
} ); */
